import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 700px;
`;

export const WrapperHeader = styled.div`
  margin-bottom: 16px;
  max-width: 610px;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.menuPrimaryDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.3;
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const Subtitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;
    margin: 0 0 40px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const WrapperForm = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 40px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 32px;
    }
  `}
`;

export const Label = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0 0 16px;
  `}
`;

export const WrapperInput = styled.div`
  max-width: 450px;
`;

export const TextFieldWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    width: 100%;

    button > svg {
      fill: ${theme.v2.colors.neutral.lowPure};
    }
  `}
`;

export const AutoComplete = styled.ul`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    height: auto;
    margin: 0px;
    max-height: 140px;
    overflow-y: auto;
    padding: 0px;
    position: absolute;
    top: 60px;
    width: 100%;
    z-index: ${theme.v2.layers.important};

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPrimary};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highDark};
      border-radius: 25px;
      height: 30px;
      width: 8px;
    }
  `}
`;

export const AutoCompleteItem = styled.li`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    cursor: pointer;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.list};
    padding: 8px 16px;

    &:hover {
      background-color: ${theme.v2.colors.brand.primaryBlue};
      color: ${theme.v2.colors.neutral.highPure};
    }
  `}
`;

export const ButtonWrapper = styled.div`
  margin: 32px 0 0;
`;
